<script>
    import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
    import Fa from "svelte-fa";

    export let headerText;
    let expanded = false;

</script>

<div class="expandable">
    <div class="header" on:click={() => expanded = !expanded}>
        <button aria-expanded={expanded}>
            {#if expanded}
                <Fa icon="{faChevronUp}" />
            {:else}
                <Fa icon="{faChevronDown}" />
            {/if}
            &nbsp;<b>{headerText}</b></button>
    </div>

    <div class="contents" hidden={!expanded}>
        <slot></slot>
    </div>
</div>

<style>
    .expandable {
        border: 1px solid #28647d;
        background-color: #F7F7F7;
    }

    .header {
        user-select: none;
        cursor: pointer;
    }

    .contents {
        padding: 1em;
    }

    button {
        background-color: #F7F7F7;
        color: #28647d;
        justify-content: space-between;
        border: none;
        margin: 0;
    }

</style>